import { render, staticRenderFns } from "./Recomendaciones.vue?vue&type=template&id=5eded2b3&scoped=true&lang=pug"
import script from "./Recomendaciones.vue?vue&type=script&lang=js"
export * from "./Recomendaciones.vue?vue&type=script&lang=js"
import style0 from "./Recomendaciones.vue?vue&type=style&index=0&id=5eded2b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eded2b3",
  null
  
)

export default component.exports